<template>
  <div class="home">
    <piece view="light">
      <template v-slot:header>
        #<span class="text-red">75-летиеПобеды</span>
      </template>

      <news-list/>
    </piece>

    <piece view="light" id="slider">
      <template v-slot:header>
        <span class="text-red">Вклад камчатцев</span><br>
        в Великую Победу
      </template>

      <slider />
    </piece>

    <piece>
      <template v-slot:header>
        <span class="text-red">Фотографии</span><br>
        из военного<br>
        прошлого Камчатки
      </template>

      <gallery />

      <template v-slot:gradient>
        <img class="piece__bg" :src="bgPicture" :srcset="`${BgPicture2x} 2x`">
      </template>
    </piece>

    <piece>
      <template v-slot:header>
        <span class="text-red">Хорошо ли вы знаете</span><br>
        военную историю Камчатки<span class="text-red">?</span>
      </template>

      <quiz />
    </piece>

    <piece>
      <template v-slot:header>
        <span class="text-red">Афиша</span><br>
        праздничных<br>
        мероприятий
      </template>

      <event-list />
    </piece>
  </div>
</template>

<script>
import Piece from '@/components/shared/Piece'
import NewsList from '@/components/news/NewsList'
import Slider from '@/components/slider/Slider'
import Gallery from '@/components/gallery/Gallery'
import Quiz from '@/components/quiz/Quiz'
import EventList from '@/components/event/EventList'
// assets
import BgPicture from '../assets/image/gallery.jpg'
import BgPicture2x from '../assets/image/gallery@2x.jpg'

export default {
  components: {
    Piece,
    Slider,
    NewsList,
    Gallery,
    Quiz,
    EventList
  },
  data () {
    return {
      bgPicture: BgPicture,
      BgPicture2x: BgPicture2x
    }
  }
}
</script>
